import { MezoModalProps } from "#/shared/types"
import { StepperModal } from "#/ui/Modal"

import ReviewAndSignStep from "./ReviewAndSignStep"

export default function StakeWithdrawalModal(props: MezoModalProps) {
  return (
    <StepperModal
      {...props}
      steps={[
        {
          title: "Withdraw",
          withCloseButton: true,
          component: ReviewAndSignStep,
        },
      ]}
    />
  )
}
